import React from 'react';
import { useTranslation } from 'react-i18next';
import { MetricCard } from '@components/MetricCard';
import { CalendarMetrics } from '../types';

interface CalendarMetricsProps {
  metrics: CalendarMetrics | null;
}

export const CalendarMetricsCards: React.FC<CalendarMetricsProps> = ({ metrics }) => {
  const { t } = useTranslation();
  if (!metrics) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {[1, 2, 3, 4].map(i => (
          <MetricCard key={i} title={t('common.loading')} value="" loading={true} />
        ))}
      </div>
    );
  }

  const metricCards = [
    {
      title: t('calendars.totalAppointments'),
      value: metrics.total_appointments,
      icon: 'event',
      variant: 'primary' as const,
      description: t('calendars.allAppointments'),
    },
    {
      title: t('calendars.upcoming'),
      value: metrics.upcoming,
      icon: 'schedule',
      variant: 'success' as const,
      description: t('calendars.scheduledAppointments'),
    },
    {
      title: t('calendars.completed'),
      value: metrics.completed,
      icon: 'check_circle',
      variant: 'success' as const,
      description: t('calendars.finishedAppointments'),
    },
    {
      title: t('calendars.cancelled'),
      value: metrics.cancelled,
      icon: 'cancel',
      variant: 'error' as const,
      description: t('calendars.cancelledAppointments'),
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {metricCards.map((card, index) => (
        <MetricCard
          key={index}
          title={card.title}
          value={card.value}
          icon={card.icon}
          variant={card.variant}
        />
      ))}
    </div>
  );
};
